import React, { useState } from "react";
import { ModalWrapper, useModal } from "../modal";
import { View } from "react-native";
import { Button } from "../button";
import { ColorPicker } from ".";
import { StyleFunction, useThemedStyle } from "../../theme";
import { useTranslation } from "locales";

type ColorPickerModalValue = { color: string };

type ColorPickerModalProps = {
    onClose: (value?: ColorPickerModalValue) => void;
    defaultColor?: string;
    color?: string;
};

export function ColorPickerModal({
    onClose,
    color,
    defaultColor,
}: ColorPickerModalProps) {
    const [currentColor, setCurrentColor] = useState<string | undefined>(
        defaultColor
    );

    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);

    return (
        <ModalWrapper
            onClose={() => onClose(undefined)}
            title={t(
                "component.color_picker_button.modal_title",
                "Pick a color"
            )}
        >
            <View style={styles.container}>
                <ColorPicker
                    color={color || currentColor}
                    onChange={newColor => {
                        setCurrentColor(newColor);
                    }}
                />
                <Button
                    onPress={() => {
                        onClose({ color: currentColor });
                    }}
                >
                    {t(
                        "component.color_picker_button.approve_text",
                        "Select this color"
                    )}
                </Button>
            </View>
        </ModalWrapper>
    );
}

export function useColorPickerModal() {
    const { render } = useModal<ColorPickerModalValue | undefined>();
    return (props: Omit<ColorPickerModalProps, "onClose">) =>
        render(
            onClose => <ColorPickerModal {...props} onClose={onClose} />,
            true
        );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        margin: theme.spacingScale * 2,
        marginTop: 0,
        gap: theme.spacingScale,
        alignItems: "center",
        flex: 1,

        minWidth: 200,
        minHeight: 300,
    },
});
